import { App } from "@capacitor/app";
import { AppLauncher } from "@capacitor/app-launcher";
import van from "vanjs-core";
import { hideLoadingScreen, router, showLoadingScreen } from "..";
import { getBillingUrl } from "../api/users_{userId}_billing";
import { assets, config } from "../app-env/common";
import { locale } from "../locale";
import { onMobile } from "../mobile";
import { state } from "../state";
import { Bulma } from "./bulma";

async function openBillingPortal() {
	showLoadingScreen();
	const returnUrl = onMobile
		? `${config.baseUrl}/redirect?uri=${encodeURIComponent((await App.getInfo()).id + "://")}`
		: undefined;

	getBillingUrl(returnUrl)
		.then((url) => {
			if (onMobile) {
				AppLauncher.openUrl({ url }).catch(() =>
					window.open(url, "_blank"),
				);
			} else {
				window.open(url, "_blank");
			}
		})
		.finally(hideLoadingScreen);
}

/**
 * @param {string} theme
 * @returns
 */
async function navbar(theme) {
	const isSignedIn = await state.isSignedIn();
	const user = await state.getSignedInUser();

	return Bulma.navbar({
		theme: theme,
		brand: [
			Bulma.navbarItem(
				{},
				van.tags.figure(
					{
						class: "image",
					},
					van.tags.img({
						src: assets["logo.png"],
					}),
				),
			),
		],
		start: [
			Bulma.navbarItem(
				{
					hidden: !isSignedIn,
					onClick: () => router.jump("/devices"),
				},
				locale.string({
					enGB: "Devices",
					deDE: "Geräte",
					frFR: "Appareils",
					svSE: "Enheter",
				}),
			),
			Bulma.navbarItem(
				{
					hidden: !isSignedIn,
					onClick: () => router.jump("/account"),
				},
				locale.string({
					enGB: "Account",
					deDE: "Konto",
					frFR: "Compte",
					svSE: "Konto",
				}),
			),
			Bulma.navbarItem(
				{
					hidden: !isSignedIn,
					onClick: openBillingPortal,
				},
				locale.strings.billing,
			),
			Bulma.navbarItem(
				{
					hidden: !isSignedIn,
					onClick: () => router.jump("/warranties"),
				},
				locale.strings.warranties,
			),
			Bulma.navbarItem(
				{
					href: locale.string({
						enGB: "https://support.luda.farm/en/support/solutions/14000076272",
						deDE: "https://support.luda.farm/de/support/solutions/14000076272",
						frFR: "https://support.luda.farm/fr/support/solutions/14000076272",
						svSE: "https://support.luda.farm/sv-SE/support/solutions/14000076272",
					}),
					target: "_blank",
				},
				locale.string({
					enGB: "Support",
					deDE: "Support",
					frFR: "Support",
					svSE: "Support",
				}),
			),
		],
		end: [
			Bulma.navbarItem(
				{
					hidden: user.AccountType !== "admin",
					onClick: () => router.jump("/admin"),
				},
				"Admin",
			),
			Bulma.navbarDropdown(
				locale.strings.language,
				setLocaleNavbarItem("English", "en-GB"),
				setLocaleNavbarItem("Deutsch", "de-DE"),
				setLocaleNavbarItem("Français", "fr-FR"),
				setLocaleNavbarItem("Svenska", "sv-SE"),
			),
			Bulma.navbarItem(
				{
					hidden: isSignedIn,
					onClick: () => router.jump("/sign-in"),
				},
				locale.strings.signIn,
			),
			Bulma.navbarItem(
				{
					hidden: !isSignedIn || state.isImpersonating(),
					onClick: signOut,
				},
				locale.string({
					enGB: "Sign out",
					deDE: "Abmelden",
					frFR: "Se déconnecter",
					svSE: "Logga ut",
				}),
			),
			Bulma.navbarItem(
				{
					hidden: !isSignedIn || !state.isImpersonating(),
					onClick: stopImpersonating,
				},
				"Stop impersonating",
			),
		],
	});
}

/**
 * @param {string} text
 * @param {Locale} id
 */
function setLocaleNavbarItem(text, id) {
	const setLocale = async () => {
		const user = await state.getSignedInUser();
		user.Locale = id;
		await state.setUser(user);

		locale.update();
		location.reload();
	};

	return Bulma.navbarItem(
		{
			onClick: setLocale,
		},
		text,
	);
}

async function signOut() {
	await state.signOut();
	router.jump("/sign-in");
}

async function stopImpersonating() {
	const user = await state.getActiveUser();
	await state.stopImpersonate();
	router.jump(`/admin/user/${user.Id}`);
}

export { navbar };
